<script setup>

import { ref, inject } from 'vue';
import ListeRoutines from './listeRoutines/ListeRoutines.vue';
import DetailRoutine from './detailRoutine/DetailRoutine.vue';
import ModaleEditionArguments from './detailRoutine/ModaleEditionArguments.vue';

const { routines } = defineProps({
  routines: Array
});

const selectionSchema = inject('selectionSchema');

const affichageModaleEditionArguments = ref(false);

function afficherModaleEditionArguments() {
	affichageModaleEditionArguments.value = true;
}

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeRoutines 
			:routines="routines"
			@edition-arguments="afficherModaleEditionArguments" />
		<DetailRoutine 
			v-if="selectionSchema.routine" 
			:routine="selectionSchema.routine"
			@edition-arguments="afficherModaleEditionArguments"  />
		<ModaleEditionArguments 
			v-if="selectionSchema.routine"
			v-model:visible="affichageModaleEditionArguments" 
			:routine="selectionSchema.routine" />
	</div>
</template>

<style scoped>
</style>